import { Environment } from '../app/models/environment';

export const environment: Environment = {
  production: false,
  apiUrl: '/api',
  imageProxyUrl: 'https://images.pantry.sh',
  oidc: {
    issuer: 'https://id.pantry.sh/realms/public',
    redirectUri: window.location.origin + '/login',
    clientId: 'pantry-stage',
    responseType: 'code',
    scope: 'openid profile email offline_access',
    showDebugInformation: true,
    sessionChecksEnabled: false,
    timeoutFactor: 0.8,
  },
  logging: {
    level: 'debug',
    serverLogLevel: 'silent',
    disableConsoleLogging: false,
    enableSourceMaps: true,
  },
};
